import React, { useEffect, useState } from 'react';
import './projetos2.css'
import HomeLf from './HomeLf';
import { db, firebaseAuth } from '../utils/firebase-config';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { collection, doc, getDocs, updateDoc } from 'firebase/firestore';
import addicon from '../assets/version2/addicon.png';
import circleadd from '../assets/version2/circleadd.png';
import Rodape from './Rodape';
import './criarordemmodal.css';
import HomeOff from './HomeOff';
function TermosDeUso(params) {

  const navigate = useNavigate();
const [current, setCurrent] = useState('');
const [logado, setLogado] = useState(false);



async function master(params) {
  


    onAuthStateChanged(firebaseAuth, async (currentUser) => {
            if (currentUser) {setLogado(true);
             setCurrent(currentUser.email);
         







        } else {
            
        }
          });





}


useEffect(()=> {

  master();

},[])


    return (
        <>
        <div>


  {logado == true ? <><HomeLf/></> : <> <HomeOff/></>}

<div className="fixmargin"></div>

<div className="row" style={{ marginTop: 50, padding: "0px 120px", paddingBottom: '200px' }}>
        <h1 style={{color: '#323743', fontSize: '48px', fontFamily: "Archivo, serif", fontWeight: 'bold'}}>TERMOS DE USO DO LUMERA 3D</h1>
    <div style={{fontSize: '14px', fontFamily: "Inter, serif", paddingTop: '50px'}}>
     
     


Data de Vigência: 06 de janeiro de 2025.
<div style={{ marginTop: '25px'}}>
Bem-vindo ao <a style={{fontWeight: 'bold'}}>Lumera 3D!</a> Estes Termos de Uso regulam o acesso e a utilização do nosso site e serviços, oferecendo orientações claras sobre as responsabilidades e direitos de nossos usuários. Ao acessar ou utilizar o <a style={{fontWeight: 'bold'}}>Lumera 3D</a>, você concorda com os termos descritos neste documento.
Por favor, leia atentamente os Termos de Uso antes de prosseguir com a utilização do site. Caso não concorde com qualquer parte destes termos, recomendamos que não utilize nossos serviços.
Nosso objetivo é fornecer uma experiência eficiente e segura para a gestão de projetos 3D, além de facilitar a colaboração entre equipes. Estes Termos de Uso garantem que todos utilizem a plataforma de forma responsável e em conformidade com as legislações aplicáveis, incluindo a <a style={{fontWeight: 'bold'}}>Lei Geral de Proteção de Dados Pessoais (LGPD)</a>.
<br/>Se você tiver dúvidas ou precisar de mais informações, entre em contato conosco através do e-mail <a style={{fontWeight: 'bold'}}>contato@lumera3d.com</a>.
</div>
<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>Agradecemos por escolher o <a style={{fontWeight: 'bold'}}>Lumera 3D</a> como seu parceiro em projetos 3D.</a>
</div>
<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>1. LICENÇA DE USO</a> <br/>
O <a style={{fontWeight: 'bold'}}>Lumera 3D</a> concede aos usuários uma licença limitada, não exclusiva, intransferível e revogável para acessar e utilizar a plataforma e seus serviços, de acordo com os Termos de Uso estabelecidos neste documento.
</div>
<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>1.1. Permissões</a> <br/>
Os usuários têm permissão para:
<li>Acessar o site e utilizar as funcionalidades disponibilizadas, como upload e gerenciamento de modelos 3D.</li>
<li>Visualizar, fazer download e interagir com o conteúdo disponibilizado, desde que para fins pessoais ou profissionais diretamente relacionados ao uso autorizado da plataforma.</li>
</div>
<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>1.2. Restrições</a> <br/>
Os usuários comprometem-se a não:
<li>Reproduzir, distribuir, modificar, criar obras derivadas, vender, alugar ou explorar comercialmente qualquer parte do site ou seus conteúdos sem autorização prévia.</li>
<li>Utilizar o site para fins ilegais, fraudulentos ou que violem direitos de terceiros.</li>
<li>Tentar acessar áreas protegidas do site sem a devida autorização.</li>
<li>Interferir no funcionamento da plataforma ou introduzir códigos maliciosos, como vírus, malwares ou bots que prejudiquem a experiência de outros usuários.</li>
<li>Utilizar ferramentas automatizadas para extrair dados da plataforma (scraping) sem permissão explícita.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>1.3. Propriedade Intelectual</a> <br/>
<li>Todos os direitos de propriedade intelectual associados ao <a style={{fontWeight: 'bold'}}>Lumera 3D</a> e seus conteúdos são de propriedade exclusiva do <a style={{fontWeight: 'bold'}}>Lumera 3D</a> ou de seus licenciadores.</li>
<li>O uso da plataforma não concede ao usuário qualquer direito de propriedade sobre marcas, logotipos, conteúdo ou funcionalidades do site.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>1.4. Revogação da Licença</a> <br/>
O <a style={{fontWeight: 'bold'}}>Lumera 3D</a> reserva-se o direito de revogar a licença de uso a qualquer momento, sem aviso prévio, caso o usuário viole os Termos de Uso ou utilize a plataforma de maneira inadequada.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>1.5. Atualizações e Modificações</a> <br/>
A plataforma pode ser atualizada ou modificada periodicamente para melhorar os serviços ou garantir conformidade com novas regulamentações. Esses ajustes podem incluir mudanças na licença de uso, sendo responsabilidade do usuário revisar os Termos de Uso regularmente.
</div>
<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>2. TERMOS PARA UPLOAD DE MODELOS 3D</a> <br/>
O <a style={{fontWeight: 'bold'}}>Lumera 3D</a> oferece aos usuários a possibilidade de fazer upload de modelos 3D para facilitar o gerenciamento de projetos e a colaboração entre equipes. Esta seção detalha as condições e responsabilidades relacionadas ao envio de arquivos para a plataforma.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>2.1. Responsabilidade pelo Conteúdo</a> <br/>
<li>O usuário declara ser o titular dos direitos autorais e de propriedade intelectual sobre os modelos 3D enviados ou possuir autorização expressa para utilizá-los e compartilhá-los.</li>
<li>O usuário é o único responsável pelos modelos enviados, incluindo a precisão das informações, eventuais violações de direitos de terceiros e quaisquer implicações legais associadas.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>2.2. Proibição de Conteúdo Inadequado</a> <br/>
Não é permitido o upload de conteúdo que:
<li>Contenha materiais ilegais, ofensivos, difamatórios ou pornográficos.</li>
<li>Viole direitos autorais, patentes, marcas registradas ou outros direitos de propriedade intelectual de terceiros.</li>
<li>Inclua vírus, malwares ou qualquer código que possa comprometer o funcionamento da plataforma ou dos dispositivos de outros usuários.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>2.3. Licença sobre os Arquivos Enviados</a> <br/>
Ao fazer upload de um modelo 3D, o usuário concede ao <a style={{fontWeight: 'bold'}}>Lumera 3D</a> uma licença limitada, não exclusiva, e isenta de royalties para:
<li>Processar, armazenar e exibir os arquivos na plataforma, conforme necessário para fornecer os serviços contratados.</li>
<li>Compartilhar os arquivos com outros membros da equipe ou terceiros autorizados pelo próprio usuário.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>2.4. Privacidade dos Arquivos</a> <br/>
<li>Os modelos enviados serão tratados como confidenciais e não serão acessados ou divulgados pelo <a style={{fontWeight: 'bold'}}>Lumera 3D</a>, salvo com o consentimento do usuário ou para cumprimento de obrigações legais.</li>
<li>O <a style={{fontWeight: 'bold'}}>Lumera 3D</a> implementa medidas de segurança para proteger os arquivos enviados, mas não se responsabiliza por acessos não autorizados decorrentes de falhas externas ou negligência do usuário.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>2.5. Armazenamento e Exclusão</a> <br/>
<li>Os arquivos enviados serão armazenados pela plataforma enquanto forem necessários para os serviços ou conforme o período estipulado pelo contrato com o usuário.</li>
<li>O usuário pode solicitar a exclusão dos arquivos a qualquer momento, salvo em situações que exijam retenção por motivos legais ou regulatórios.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>2.6. Violações</a> <br/>
Caso um modelo enviado viole os Termos de Uso, o <a style={{fontWeight: 'bold'}}>Lumera 3D</a> reserva-se o direito de:
<li>Remover o arquivo sem aviso prévio.</li>
<li>Suspender ou encerrar a conta do usuário, em caso de reincidência ou violações graves.</li>
<li>Reportar atividades ilegais às autoridades competentes, quando necessário.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>2.7. Isenção de Responsabilidade</a> <br/>
O <a style={{fontWeight: 'bold'}}>Lumera 3D</a> não é responsável pelo uso indevido dos modelos 3D por outros usuários ou terceiros. A responsabilidade pelo compartilhamento e uso adequado dos arquivos é do próprio usuário.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>3. POLÍTICA DE CANCELAMENTO E REEMBOLSO</a> <br/>
O <a style={{fontWeight: 'bold'}}>Lumera 3D</a> busca oferecer a melhor experiência aos seus usuários e, para isso, estabelece uma Política de Cancelamento e Reembolso clara e transparente. Leia atentamente esta seção para entender as condições aplicáveis.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>3.1. Cancelamento de Serviços</a> <br/>
<li>O usuário pode solicitar o cancelamento de serviços contratados diretamente na plataforma ou por meio do e-mail <a style={{fontWeight: 'bold'}}>contato@lumera3d.com</a>.</li>
<li>O cancelamento será processado em até 7 dias úteis a partir da solicitação.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>3.2. Período de Arrependimento (Conforme o Código de Defesa do Consumidor)</a> <br/>
<li>De acordo com o Art. 49 do Código de Defesa do Consumidor, o usuário tem até 7 dias corridos após a contratação ou pagamento para solicitar o cancelamento e o reembolso integral, desde que o serviço não tenha sido totalmente utilizado.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>3.3. Reembolsos</a> <br/>
<li>Os reembolsos serão processados dentro de 10 dias úteis após a aprovação da solicitação.</li>
<li>O valor será reembolsado para a mesma forma de pagamento utilizada pelo usuário no ato da compra.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>3.4. Condições para Reembolso</a> <br/>
O reembolso será aplicável nas seguintes situações:
<li>Solicitação dentro do período de arrependimento.</li>
<li>Erro ou falha técnica comprovada na prestação do serviço.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>3.5. Situações em que o Reembolso Não é Aplicável</a> <br/>
<li>Serviços já utilizados ou entregues, como downloads de arquivos ou upload de modelos processados.</li>
<li>Cancelamentos fora do período de arrependimento sem motivo justificado.</li>
<li>Violações dos Termos de Uso por parte do usuário.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>3.6. Procedimento para Cancelamento e Reembolso</a> <br/>
<li>O usuário deve entrar em contato pelo e-mail <a style={{fontWeight: 'bold'}}>contato@lumera3d.com</a> com as seguintes informações:</li>
<li style={{paddingLeft: '10px'}}>Nome completo.</li>
<li style={{paddingLeft: '10px'}}>Serviço contratado.</li>
<li style={{paddingLeft: '10px'}}>Motivo do cancelamento ou reembolso.</li>
<li>O <a style={{fontWeight: 'bold'}}>Lumera 3D</a> analisará a solicitação e enviará um retorno em até 5 dias úteis.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>3.7. Cancelamento pela Plataforma</a> <br/>
<li>O <a style={{fontWeight: 'bold'}}>Lumera 3D</a> reserva-se o direito de cancelar unilateralmente serviços contratados pelo usuário, nas seguintes situações:</li>
<li>Violação dos Termos de Uso ou Política de Privacidade.</li>
<li>Atividades fraudulentas ou ilegais detectadas na conta do usuário.</li>
<li>Inadimplência no pagamento.</li>
Nesses casos, o usuário será notificado com antecedência e orientado sobre os próximos passos.
</div>


<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>4. AVISO LEGAL</a> <br/>
O presente Aviso Legal rege o uso do site <a style={{fontWeight: 'bold'}}>Lumera 3D</a> e estabelece as limitações de responsabilidade e os termos gerais que devem ser observados pelos usuários. Ao acessar a plataforma, você concorda com as condições descritas a seguir.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>4.1. Informações Gerais</a> <br/>
<li>O <a style={{fontWeight: 'bold'}}>Lumera 3D</a> oferece ferramentas para o gerenciamento de projetos 3D e armazenamento de modelos 3D. Embora nos esforcemos para garantir a precisão e funcionalidade dos serviços, não garantimos que o site estará isento de erros ou interrupções.</li>
<li>O conteúdo do site, incluindo textos, imagens e funcionalidades, é fornecido "no estado em que se encontra" e está sujeito a alterações sem aviso prévio.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>4.2. Limitação de Responsabilidade</a> <br/>
<li>O <a style={{fontWeight: 'bold'}}>Lumera 3D</a> não se responsabiliza por danos diretos, indiretos, incidentais ou consequenciais decorrentes do uso ou incapacidade de uso da plataforma, incluindo perda de dados, interrupções de serviço ou danos causados por erros técnicos.</li>
<li>Não garantimos que os modelos 3D enviados pelos usuários estejam livres de falhas ou sejam adequados para fins específicos. A responsabilidade pelo uso adequado dos arquivos enviados ou recebidos recai exclusivamente sobre os usuários.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>4.3. Responsabilidade do Usuário</a> <br/>
<li>É de responsabilidade do usuário garantir que o uso da plataforma está em conformidade com as leis aplicáveis e os Termos de Uso.</li>
<li>O usuário deve manter backup de seus arquivos e não deve depender exclusivamente da plataforma para armazenamento de informações críticas.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>4.4. Conteúdo de Terceiros</a> <br/>
<li>O site pode conter links ou referências a conteúdos de terceiros. O <a style={{fontWeight: 'bold'}}>Lumera 3D</a> não se responsabiliza pela precisão, qualidade ou disponibilidade desses conteúdos, nem pelo uso que você fizer dessas informações.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>4.5. Segurança</a> <br/>
Embora empreguemos medidas de segurança para proteger os dados e informações do usuário, não podemos garantir proteção absoluta contra ataques cibernéticos ou falhas imprevistas. Recomendamos que os usuários adotem práticas seguras, como o uso de senhas fortes e atualizações regulares de seus dispositivos.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>4.6. Atualizações do Aviso Legal</a> <br/>
Este Aviso Legal pode ser alterado periodicamente para refletir atualizações no serviço ou mudanças legais. É responsabilidade do usuário revisar este documento regularmente para manter-se informado.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>4.7. Jurisdição</a> <br/>
Este Aviso Legal é regido pelas leis da República Federativa do Brasil. Fica eleito o foro da comarca de Canoas, Rio Grande do Sul, para resolver quaisquer questões relacionadas ao seu conteúdo.
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>5. DISPOSIÇÕES GERAIS</a> <br/>
<li>As disposições gerais deste documento complementam e reforçam as diretrizes apresentadas nos Termos de Uso, assegurando que todos os aspectos legais e operacionais da utilização da plataforma <a style={{fontWeight: 'bold'}}>Lumera 3D</a> sejam devidamente compreendidos e aplicados.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>5.1. Integralidade do Contrato</a> <br/>
<li>Estes Termos de Uso, juntamente com a Política de Privacidade, representam o acordo integral entre o usuário e o <a style={{fontWeight: 'bold'}}>Lumera 3D</a>, substituindo quaisquer entendimentos ou acordos anteriores.</li>
<li>Caso alguma disposição destes termos seja considerada inválida ou inexequível, as demais permanecerão em pleno vigor e efeito.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>5.2. Alterações nos Termos</a> <br/>
<li>O <a style={{fontWeight: 'bold'}}>Lumera 3D</a> reserva-se o direito de alterar, a qualquer momento, os Termos de Uso e documentos relacionados para refletir atualizações nos serviços ou mudanças legais.</li>
<li>Alterações substanciais serão comunicadas aos usuários com antecedência, por meio do site ou de e-mail cadastrado.</li>
<li>O uso continuado da plataforma após a atualização dos termos implica na aceitação das mudanças.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>5.3. Relação entre as Partes</a> <br/>
<li>Estes Termos de Uso não criam qualquer relação de sociedade, parceria, representação ou vínculo empregatício entre o usuário e o <a style={{fontWeight: 'bold'}}>Lumera 3D</a>.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>5.4. Legislação Aplicável</a> <br/>
<li>Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil e devem ser interpretados de acordo com as mesmas.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>5.5. Renúncia</a> <br/>
<li>A falha do <a style={{fontWeight: 'bold'}}>Lumera 3D</a> em exigir o cumprimento de qualquer disposição destes termos não será considerada uma renúncia de direitos, podendo exercer tais direitos a qualquer momento.</li>
</div>

<div style={{ marginTop: '25px'}}>
<a style={{fontWeight: 'bold'}}>5.6. Contato</a> <br/>
Em caso de dúvidas ou necessidade de esclarecimentos adicionais, entre em contato conosco por meio do e-mail <a style={{fontWeight: 'bold'}}>contato@lumera3d.com</a>.
</div>






       
        </div>
</div>





        </div>

        <Rodape/>
        </>

    )
}
export default TermosDeUso;